export default {
    driver_performance_case_overview_eventName: "Tipo de Evento",
    driver_performance_case_overview_count: "Conteo",
    driver_performance_case_overview_priorCoaching: "Entrenamiento previo",
    driver_performance_case_overview_caseId: "ID del Caso",
    driver_performance_case_overview_status: "Estado",
    driver_performance_case_overview_created: "Creado",
    driver_performance_case_overview_piSuccess: "Éxito de PI",
    driver_performance_case_overview_metric: "Métrica",
    driver_performance_case_overview_measure: "Medida",
    driver_performance_case_overview_risk: "Riesgo",
    driver_performance_case_overview_coachingHistory: "Historial de entrenamiento",
    driver_performance_case_overview_performanceHistory: "Historial de Rendimiento",
    driver_performance_case_totalEvents: "Total de Eventos",
    driver_performance_case_avgEvents: "Promedio de Eventos",
    driver_performance_case_riskScore: "Puntuación de Riesgo",
    driver_performance_case_totalDistance: "Distancia Total",
    driver_performance_case_pendingAssing: "Pendiente",
    driver_performance_case_pendingAssign: "Pendiente",
    driver_performance_case_pendingInitiate: "Pendiente",
    driver_performance_case_evaluate: "Evaluar",
    driver_performance_case_completedOmitedPI: "Completado",
    driver_performance_case_completed: "Completado",
    driver_performance_case_Expired: "Expirado",
    driver_performance_case_evaluateJudgement: "Evaluar",
    driver_performance_case_escalateMonitor: "Escalar",
    driver_performance_case_escalateJudgement: "Escalar",
    driver_performance_case_completedFailedPI: "Completado",
    driver_performance_case_AssingCoach: "Asignar Supervisor",
    driver_performance_case_AssignCoach: "Asignar Supervisor",
    driver_performance_case_InitiateCoaching: "Iniciar Supervisión",
    driver_performance_case_Monitor: "Monitorear",
    driver_performance_case_PIOmited: "PI Omitido",
    driver_performance_case_PISuccessfull: "PI Exitoso",
    driver_performance_case_Judgement: "Juicio",
    driver_performance_case_Monitoring: "Monitoreo",
    driver_performance_case_Judging: "Judging",
    driver_performance_case_PIFailed: "PI Failed",
    driver_performance_case_yes: "Si",
    driver_performance_case_no: "No",
    driver_performance_case_expired: "Expirado",
}
